module.exports = __webpack_public_path__ + "img/bg_login.179b68c2.jpg";